<template>
  <b-tab :title="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterTabLabel">
    <div v-for="item in fuelTankConsumptionInfos" v-bind:key="item.id">
      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterNameLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="item.name"
          :state="isValidName"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterInputLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          readonly
          v-model="item.fuelInput"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterDirectionLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          readonly
          v-model="item.fuelDirection"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        v-bind:label="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterTypeLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          readonly
          v-model="item.type"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterSensorVerificationDateLabel"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="item.sensorVerificationDate"
          placeholder="Выберите дату"
          locale="ru"
          autocomplete="off"
          size="sm"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterSensorVerificationNumberLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="item.sensorVerificationNumber"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelCounterSensorVerificationFileNameLabel"
        label-for="input-horizontal"
      >
        <b-link href="#" @click.prevent="downloadVerificationFile(item)">{{
          item.sensorVerificationFileName
        }}</b-link>

        <b-form-file
          v-model="item.sensorVerificationFile"
          placeholder="Загрузить файл"
          drop-placeholder="Drop file here..."
          plain
          accept=".jpg, .png, .gif, .pdf, .doc, .docx"
        ></b-form-file>
      </b-form-group>

      <hr />
    </div>
  </b-tab>
</template>

<script>
import { utilsService, fuelTankService } from "../../../services";

export default {
  name: "FuelCounterTab",
  props: {
    fuelTankCard: Object,
  },
  data() {
    return {
      fuelTankConsumptionInfos: [],
      isValidName: null
    };
  },
  created() {
    this.fuelTankConsumptionInfos = [];

    for (
      let i = 0;
      i < this.fuelTankCard.fuelTankConsumptionInfos.length;
      i++
    ) {
      const fuelTankConsumptionInfo = {
        id: this.fuelTankCard.fuelTankConsumptionInfos[i].id,
        name: this.fuelTankCard.fuelTankConsumptionInfos[i].name,
        fuelDirection: this.convertFuelInputDirectionFromIdToName(
          this.fuelTankCard.fuelTankConsumptionInfos[i].fuelDirection
        ),
        fuelInput: this.fuelTankCard.fuelTankConsumptionInfos[i].fuelInput,
        type: this.convertFuelConsumptionTypeFromIdToName(
          this.fuelTankCard.fuelTankConsumptionInfos[i].type
        ),
        sensorVerificationNumber:
          this.fuelTankCard.fuelTankConsumptionInfos[i]
            .sensorVerificationNumber,
        sensorVerificationFileName:
          this.fuelTankCard.fuelTankConsumptionInfos[i]
            .sensorVerificationFileName,
      };

      if (this.fuelTankCard.sensorVerificationDate) {
        this.sensorVerificationDate = utilsService.convertUnixTimeToDate(
          this.fuelTankCard.sensorVerificationDate
        );
      }

      if (
        this.fuelTankCard.fuelTankConsumptionInfos[i].sensorVerificationDate !=
        0
      ) {
        fuelTankConsumptionInfo.sensorVerificationDate =
          utilsService.convertUnixTimeToDate(
            this.fuelTankCard.fuelTankConsumptionInfos[i].sensorVerificationDate
          );
      }

      this.fuelTankConsumptionInfos.push(fuelTankConsumptionInfo);
    }
  },
  methods: {
    async downloadVerificationFile(item) {
      await fuelTankService.downloadFuelConsumptionSensorVerificationFile(
        item.sensorVerificationFileName,
        item.id,
        this.convertFuelConsumptionTypeFromNameToId(item.type)
      );
    },
    convertFuelInputDirectionFromIdToName(id) {
      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .fuelConsumptionDirection.length;
        i++
      ) {
        if (
          this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionDirection[i].id == id
        ) {
          return this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionDirection[i].name;
        }
      }
    },
    convertFuelInputDirectionFromNameToId(name) {
      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .fuelConsumptionDirection.length;
        i++
      ) {
        if (
          this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionDirection[i].name == name
        ) {
          return this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionDirection[i].id;
        }
      }
    },
    convertFuelConsumptionTypeFromIdToName(id) {
      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .fuelConsumptionType.length;
        i++
      ) {
        if (
          this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionType[i].id == id
        ) {
          return this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionType[i].name;
        }
      }
    },
    convertFuelConsumptionTypeFromNameToId(name) {
      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .fuelConsumptionType.length;
        i++
      ) {
        if (
          this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionType[i].name == name
        ) {
          return this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelConsumptionType[i].id;
        }
      }
    },
    validate() {
      let isValid = true;
      
      for (let i = 0; i < this.fuelTankConsumptionInfos.length; i++) {
        if (!this.fuelTankConsumptionInfos[i].name) {
          this.isValidName = false;
          isValid = false;
        } else {
          this.isValidName = null;
        }
      }

      return isValid;
    },
    async getFuelTankConsumptionInfos() {
      const fuelTankConsumptionInfos = [];

      for (let i = 0; i < this.fuelTankConsumptionInfos.length; i++) {
        const fuelTankConsumptionInfo = {
          id: this.fuelTankConsumptionInfos[i].id,
          type: this.convertFuelConsumptionTypeFromNameToId(
            this.fuelTankConsumptionInfos[i].type
          ),
          name: this.fuelTankConsumptionInfos[i].name
        };

        if (this.fuelTankConsumptionInfos[i].sensorVerificationNumber) {
          fuelTankConsumptionInfo.sensorVerificationNumber =
            this.fuelTankConsumptionInfos[i].sensorVerificationNumber;
        }

        if (this.fuelTankConsumptionInfos[i].sensorVerificationDate) {
          fuelTankConsumptionInfo.sensorVerificationDate = Date.parse(
            this.fuelTankConsumptionInfos[i].sensorVerificationDate
          );
        }

        if (this.fuelTankConsumptionInfos[i].sensorVerificationFile) {
          const buffer = await this.fuelTankConsumptionInfos[
            i
          ].sensorVerificationFile.arrayBuffer();

          fuelTankConsumptionInfo.sensorVerificationFile =
            utilsService.arrayBufferToBase64(buffer);
          fuelTankConsumptionInfo.sensorVerificationFileName =
            this.fuelTankConsumptionInfos[i].sensorVerificationFile.name;
        }

        fuelTankConsumptionInfos.push(fuelTankConsumptionInfo);
      }

      return fuelTankConsumptionInfos;
    },
  },
};
</script>
